var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.productsPricing
    ? _c("div", { staticClass: "preference" }, [
        _c(
          "div",
          { staticClass: "column flex-1" },
          [
            _c("div", { staticClass: "row" }, [
              _c("p", [_vm._v(_vm._s(_vm.configurableField.display_name))])
            ]),
            _vm._v(" "),
            _vm._l(_vm.configurableFieldOptions, function(option) {
              return _c(
                "div",
                { key: option.id, staticClass: "row radio-item" },
                [
                  _c("label", [
                    _c("input", {
                      attrs: { type: "radio", name: option.display_name },
                      domProps: {
                        value: option.opt_id,
                        checked: option.opt_id == _vm.answer
                      },
                      on: {
                        change: function($event) {
                          _vm.handleAnswerChange(option)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(option.display_name) +
                          " " +
                          _vm._s(
                            option.opt_id === 1
                              ? "(+ " +
                                _vm.$options.filters.toCurrency(
                                  _vm.productsPricing.fee +
                                    _vm.productsPricing.price +
                                    (_vm.productsPricing.fee_per_hour +
                                      _vm.productsPricing.price_per_hour) *
                                      _vm.duration
                                ) +
                                ")"
                              : ""
                          )
                      )
                    ])
                  ])
                ]
              )
            })
          ],
          2
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a1d16ac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a1d16ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Components/Scheduler/Confirmation/ProductsPreference.vue
// module id = null
// module chunks = 